module.exports = __webpack_public_path__ + "static/media/sensable_33.ed4a09aa.gif";